import { FlowPricingMode, FlowRunCostDataSource } from 'flow-schema';
import { MoneySchema } from 'notable-common';
import { z } from 'zod';

import { AnyBlockTypeSchema } from './base/baseSchema.js';

export const FlowRunCostBlockLineItemSchema = z.object({
  blockType: AnyBlockTypeSchema,
  skillBillingKey: z.string().nullable().optional(),
  displayName: z.string().nullable().optional(),
  totalCost: MoneySchema,
  lineItems: z.array(
    z.object({
      id: z.string().optional(),
      totalCost: MoneySchema,
      unitCostDescription: z.string(),
      usageDescription: z.string(),
      llmModel: z.string().nullable().optional(),
    })
  ),
});

export type FlowRunCostBlockLineItem = z.infer<typeof FlowRunCostBlockLineItemSchema>;

export const FlowRunCostResponseSchema = z.object({
  flowRunId: z.string(),
  totalCost: MoneySchema,
  dataSource: z.enum(FlowRunCostDataSource),
  /** How this run's own events were metered; subflows are priced independently. */
  pricingMode: z.enum(FlowPricingMode),
  blockLineItems: z.array(FlowRunCostBlockLineItemSchema),
  subflowLineItems: z.array(
    z.object({
      name: z.string(),
      totalCost: MoneySchema,
      flowRunId: z.string(),
      blockLineItems: z.array(FlowRunCostBlockLineItemSchema).optional(),
    })
  ),
  pendingRateLineItems: z.array(
    z.object({
      blockType: AnyBlockTypeSchema,
      skillBillingKey: z.string().nullable().optional(),
      displayName: z.string().nullable().optional(),
    })
  ),
});

export type FlowRunCostResponse = z.infer<typeof FlowRunCostResponseSchema>;
